import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function MoreFeatures() {
    return (
        <OnboardingBody title='Unlock the full potential'>
            <p>Maximize Scheduler’s capabilities with these advanced features:</p>
            <BulletedList
                bullets={[
                    <span key='1'>
                        Automatically create or update leads from new Scheduler bookings.
                    </span>,
                    <span key='2'>Stay in the loop with real-time booking notifications.</span>,
                    <span key='3'>Send automated reminder emails to meeting attendees.</span>,
                ]}
            />
        </OnboardingBody>
    );
}
